import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { ISettingsHasPartners } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/syndication-api/settings_has_partners';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    { path: 'partner', alias: 'p' },
  ],
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [
    { path: 'partner', alias: 'p' },
  ],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ISettingsHasPartners>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced, // 'settings-has-partners/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
